export class FormMatrix{
  UXControllerMatrixID : string;
  UXControllerMatrices : any;

  constructor(UXControllerMatrixID, UXControllerMatrices){
    this.UXControllerMatrices = UXControllerMatrices;
    this.UXControllerMatrixID = UXControllerMatrixID;
  }
}
